import { Box, Typography } from "@mui/material";
import * as React from "react";

export interface IToolTitleProp {
    title: string | React.ReactNode;
    classes?: string;
    labelClasses?: string;
}

export class ToolTitle extends React.Component<IToolTitleProp, {}> {
    render() {
        const props = this.props;
        return (
            <Box>
                <Typography variant="caption" sx={{ color: "text.secondary" }}>{props.title}</Typography>
            </Box>
        );
    }
}